import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Home from './components/Home';
import RobloxProfile from './components/RobloxProfile';
import Stories from './components/Stories';
import Sports from './components/Sports';
import Videos from './components/Videos';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <motion.nav 
          className="navbar"
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              DANDRE
            </Link>
            <div className="nav-links">
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/roblox" className="nav-link">Roblox</Link>
              <Link to="/stories" className="nav-link">Stories</Link>
              <Link to="/sports" className="nav-link">Sports</Link>
              <Link to="/videos" className="nav-link">Videos</Link>
            </div>
          </div>
        </motion.nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/roblox" element={<RobloxProfile />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/videos" element={<Videos />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;